import { render, staticRenderFns } from "./navi.vue?vue&type=template&id=4afb8348&"
import script from "./navi.vue?vue&type=script&lang=js&"
export * from "./navi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4afb8348', component.options)
    } else {
      api.reload('4afb8348', component.options)
    }
    module.hot.accept("./navi.vue?vue&type=template&id=4afb8348&", function () {
      api.rerender('4afb8348', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Partials/navi.vue"
export default component.exports